import { BaseWidgetComponent } from '@adaptiva/core/widgets';
import { IBaseEditorError, ISchedule } from '@adaptiva/data-service';
import { Directive, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ISchedulePropertyChange, ISchedulePropertyOutput } from '../interfaces';

@Directive()
export abstract class BaseScheduleTypeComponent extends BaseWidgetComponent implements OnChanges {

	@Input()
	public schedule: ISchedule;

	@Output()
	public valueChange: EventEmitter<ISchedulePropertyOutput> = new EventEmitter();

	@HostBinding('style.width')
	public override width: string = '100%';
	
	public override ngOnChanges(_changes: SimpleChanges): void {
		super.ngOnChanges(_changes);

		if (_changes.schedule)
			this.commitModelToView();
	}

	abstract commitModelToView(): void;

	abstract validate(): IBaseEditorError[];

	public outputChanges(_changes: ISchedulePropertyChange[]): void {
		this.valueChange.emit({
			changes: _changes
		});
	}

}
